<template>
  <b-row>
    <b-col sm="6">
      Mostrando {{primeiroRegistroPagina}} até {{ultimoRegistroPagina}} de {{totalItens}} registros
    </b-col>
    <b-col sm="6">
      <div class="d-flex flex-row-reverse bd-highlight">
        <div>
          <b-pagination size="md" align="right" :total-rows="totalItens" v-model="paginaAtual" :per-page="itensPorPagina">
          </b-pagination>
        </div>
        <div class="mr-2">
          <slot name="paginacao"></slot>
        </div>
        <div class="mr-2 pt-2">
          <span>Itens por Página</span>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    name: 'app-paginacao-tabela',
    props: {
      totalItens: {
        type: Number,
        default: 0
      },
      itensPorPagina: {
        type: Number,
        default: 5
      },
      value: {
        type: Number
      }
    },
    data () {
      return {
        paginaAtual: 1
      }
    },
    watch: {
      paginaAtual () {
        this.$emit('input', this.paginaAtual)
      },
      value () {
        if (this.value !== this.paginaAtual) {
          this.paginaAtual = this.value
        }
      }
    },
    computed: {
      primeiroRegistroPagina () {
        return this.totalItens === 0 ? this.totalItens : ((this.paginaAtual - 1) * this.itensPorPagina) + 1
      },
      ultimoRegistroPagina () {
        return this.totalItens - this.primeiroRegistroPagina < this.itensPorPagina ? this.totalItens : this.primeiroRegistroPagina + this.itensPorPagina - 1
      }
    }
  }
</script>
